module.exports = __webpack_public_path__ + "fonts/tragic-marker-regular.9f9d35b6.eot";